import {  MAT_DIALOG_DATA } from '@angular/material/dialog';
import { tracking_response_item_model } from '../tracking-item.model';
import {
  Component,
  ViewEncapsulation,
  ViewChild,
  OnInit,
  ChangeDetectorRef,
  Inject,
  ElementRef
} from '@angular/core';
import Swiper, { SwiperOptions } from 'swiper';
@Component({
  selector: 'tracking-item-proof-photo-dialog',
  templateUrl: 'tracking-item-proof-photo-dialog.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls :['tracking-item-proof-photo-dialog.css']
})


 export class TrackingItemProofPhotoDialog implements OnInit {
  @ViewChild('swiper1') swiper1!: ElementRef<any>;
  @ViewChild('swiper2') swiper2!: ElementRef<any>;

  slides: any[] = [];
  consignmentNo: string = ''
  descLocation: string = ''
  constructor(@Inject(MAT_DIALOG_DATA) public data: tracking_response_item_model,private cdr: ChangeDetectorRef) {}
  ngOnInit() {

    let epodPhotoTemp = this.data.shipment.epod_photo.length > 3 ? this.data.shipment.epod_photo.slice(0, 3) : this.data.shipment.epod_photo;

    let epodPhotos = Object.keys(epodPhotoTemp).map(key => {
      return {id: key, image: epodPhotoTemp[key], type : 'jpeg'}
    });

    this.consignmentNo = this.data.shipment.con
    this.descLocation = this.data.shipment.desc_location
    if(this.data.shipment.sig !=undefined && this.data.shipment.sig != " " && this.data.shipment.sig != null && this.data.shipment.sig.length > 0)
      {
        this.slides.push({id: epodPhotos.length, image: this.data.shipment.sig, type : 'base64'})
      }

      epodPhotos.forEach(x=> this.slides.push(x));
    //this.slides = epodPhotos

    if (this.swiper1?.nativeElement) {
      this.swiper1.nativeElement.swiper.destroy();
      this.swiper1.nativeElement.initialized = false;
      this.swiper1.nativeElement.initialize();
    }
    if (this.swiper2?.nativeElement) {
      this.swiper2.nativeElement.swiper.destroy();
      this.swiper2.nativeElement.initialized = false;
      this.swiper2.nativeElement.initialize();
    }
  }
  ngAfterViewInit(){
    
    const swiperParams = {
      updateOnWindowResize: true
    };

    const swiperParams1 = {};
    Object.assign(this.swiper1.nativeElement, swiperParams1);
    this.swiper1.nativeElement.initialize();

    // now we need to assign all parameters to Swiper element
    Object.assign(this.swiper2.nativeElement, swiperParams);
    this.swiper2.nativeElement.initialize();
  }
  
 }
